import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.bonusTransactions
)

export const selectBonusTransactionsError = createSelector(
    baseSelector,
    (state) => state.error
)
export const selectBonusTransactions = createSelector(
    baseSelector,
    (state) => state.transactions
)
export const selectBonusTransactionsStores = createSelector(
    baseSelector,
    (state) => state.stores
)
export const selectBonusTransactionsChecks = createSelector(
    baseSelector,
    (state) => state.checks
)
export const selectBonusTransactionsLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)
export const selectBonusTransactionsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)
export const selectBonusTransactionsCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)
